import { PercentPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { LocaleService } from '../../services/locale.service';

@Pipe({ name: 'appPercent' })
export class AppPercentPipe implements PipeTransform {
  private appPercentPipe!: PercentPipe;

  public constructor(
    private localeService: LocaleService) {
    this.localeService.getCurrentLocaleSubject().subscribe((locale) => {
      this.appPercentPipe = new PercentPipe(locale.currentLocaleJS);
    });
  }

  public transform(value: number, digitsInfo: string = '1.0-0'): string | null {
    return this.appPercentPipe.transform(value, digitsInfo);
  }
}
